import { formatFileSize } from '../../utils/format';

/** A 0-100 value as a percentage. */
export function formatPercent(value: number): string {
  return `${value.toFixed(1)}%`;
}

/** A bytes-per-second figure, e.g. "1.5 MB/s". Used for disk throughput. */
export function formatRate(bytesPerSecond: number): string {
  return `${formatFileSize(Math.round(bytesPerSecond))}/s`;
}

/**
 * A megabits-per-second figure, e.g. "57.6 Mbps". Used for network throughput.
 *
 * The precision tapers because the same axis has to read sensibly at both ends:
 * a saturated gigabit link needs no decimals, and an idle one would show "0.0"
 * for everything without two.
 */
export function formatMbps(mbps: number): string {
  if (mbps === 0) return '0 Mbps';
  if (mbps >= 100) return `${Math.round(mbps)} Mbps`;
  if (mbps >= 10) return `${mbps.toFixed(1)} Mbps`;

  return `${mbps.toFixed(2)} Mbps`;
}

/**
 * Wall-clock time for an x-axis label or a hover readout.
 *
 * Time only, no date: the whole window is minutes to hours wide, so a date
 * would be the same on every label and cost the space the time needs.
 */
export function formatClockTime(unixSeconds: number): string {
  return new Date(unixSeconds * 1000).toLocaleTimeString();
}
